export default "__VITE_ASSET__DFqzZVab__"